<script setup>
// El cuadrado de una tela: la foto cuando hay, y el dibujo del material cuando
// todavía no. Vive aparte porque lo usan el muestrario y la ficha, y el
// cuadrado tiene que ser el mismo cuadrado en los dos lados.
defineProps({
  fabric: { type: Object, required: true },
  // La grilla baja sus muestras cuando toca; la de la ficha ya se está mirando.
  loading: { type: String, default: 'lazy' }
})
</script>

<template>
  <img
    v-if="fabric.swatch"
    :src="fabric.swatch"
    :alt="`Muestra de tela ${fabric.name.toLowerCase()}`"
    width="600"
    height="600"
    :loading="loading"
    decoding="async"
    class="aspect-square w-full object-cover"
  />
  <div
    v-else
    class="swatch aspect-square w-full"
    :class="`swatch--${fabric.pattern}`"
    :style="{ '--tone': fabric.tone }"
    aria-hidden="true"
  ></div>
</template>

<style scoped>
/* Relleno, nada más: una trama en el tono de la tela, para que el cuadrado se
   lea como un dibujo del material y no como una foto que no cargó. Desaparece
   apenas `swatch` apunta a una imagen de verdad. */
.swatch {
  background-color: var(--tone);
}

.swatch--weave {
  background-image:
    repeating-linear-gradient(45deg, rgb(255 255 255 / 0.07) 0 2px, transparent 2px 5px),
    repeating-linear-gradient(-45deg, rgb(0 0 0 / 0.09) 0 2px, transparent 2px 5px);
}

/* Duo es bandas alternadas, así que su relleno son bandas alternadas. */
.swatch--bands {
  background-image:
    repeating-linear-gradient(
      0deg,
      rgb(255 255 255 / 0.24) 0 11px,
      rgb(0 0 0 / 0.14) 11px 22px
    );
}
</style>
